export const gateway = "https://wpg-plan-bms-api.link.wawanesalife.com";
export const LoginUrlParameter = "https://stable-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=6plicmk161t528ev28ee9omosb&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fwpg-plan-bms.link.wawanesalife.com%2Fredirect";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "6plicmk161t528ev28ee9omosb";
export const BrokerPoolDomainParameter = "stable-brokers";
export const BrokerPoolParameter = "ca-central-1_smmgFhHsy";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://wpg-plan.link.wawanesalife.com";

//updated on Wed Jul 08 2026 14:39:05 GMT-0500 (Central Daylight Time)
